import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { forwardRef, memo, useRef } from 'react';
import clsx from 'clsx';
import { EditorContainer, EditorPortal } from './editors';
import { wrapEvent } from './utils';
import { useCombinedRefs } from './hooks';

function Cell(_ref, ref) {
  var className = _ref.className,
      column = _ref.column,
      isCopied = _ref.isCopied,
      isDraggedOver = _ref.isDraggedOver,
      isRowSelected = _ref.isRowSelected,
      lastFrozenColumnIndex = _ref.lastFrozenColumnIndex,
      row = _ref.row,
      rowIdx = _ref.rowIdx,
      eventBus = _ref.eventBus,
      selectedCellProps = _ref.selectedCellProps,
      onRowClick = _ref.onRowClick,
      onKeyDown = _ref.onKeyDown,
      onClick = _ref.onClick,
      onDoubleClick = _ref.onDoubleClick,
      onContextMenu = _ref.onContextMenu,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "column", "isCopied", "isDraggedOver", "isRowSelected", "lastFrozenColumnIndex", "row", "rowIdx", "eventBus", "selectedCellProps", "onRowClick", "onKeyDown", "onClick", "onDoubleClick", "onContextMenu"]);

  var cellRef = useRef(null);
  var isSelected = selectedCellProps !== undefined;
  var isEditing = (selectedCellProps === null || selectedCellProps === void 0 ? void 0 : selectedCellProps.mode) === 'EDIT';
  var cellClass = column.cellClass;
  className = clsx('rdg-cell', {
    'rdg-cell-frozen': column.frozen,
    'rdg-cell-frozen-last': column.idx === lastFrozenColumnIndex,
    'rdg-cell-selected': isSelected,
    'rdg-cell-copied': isCopied,
    'rdg-cell-dragged-over': isDraggedOver
  }, typeof cellClass === 'function' ? cellClass(row) : cellClass, className);

  function selectCell(openEditor) {
    eventBus.dispatch('SELECT_CELL', {
      idx: column.idx,
      rowIdx: rowIdx
    }, openEditor);
  }

  function handleClick() {
    selectCell();
    onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(rowIdx, row, column);
  }

  function handleContextMenu() {
    selectCell();
  }

  function handleDoubleClick() {
    selectCell(true);
  }

  function onRowSelectionChange(checked, isShiftClick) {
    eventBus.dispatch('SELECT_ROW', {
      rowIdx: rowIdx,
      checked: checked,
      isShiftClick: isShiftClick
    });
  }

  function getCellContent() {
    if (selectedCellProps && selectedCellProps.mode === 'EDIT') {
      var _selectedCellProps$ed = selectedCellProps.editorContainerProps,
          editorPortalTarget = _selectedCellProps$ed.editorPortalTarget,
          editorProps = _objectWithoutPropertiesLoose(_selectedCellProps$ed, ["editorPortalTarget"]);

      var _ref2 = document.scrollingElement || document.documentElement,
          docTop = _ref2.scrollTop,
          docLeft = _ref2.scrollLeft;

      var _cellRef$current$getB = cellRef.current.getBoundingClientRect(),
          left = _cellRef$current$getB.left,
          top = _cellRef$current$getB.top;

      var gridLeft = left + docLeft;
      var gridTop = top + docTop;
      return /*#__PURE__*/React.createElement(EditorPortal, {
        target: editorPortalTarget
      }, /*#__PURE__*/React.createElement(EditorContainer, Object.assign({}, editorProps, {
        rowIdx: rowIdx,
        row: row,
        column: column,
        left: gridLeft,
        top: gridTop
      })));
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(column.formatter, {
      column: column,
      rowIdx: rowIdx,
      row: row,
      isCellSelected: isSelected,
      isRowSelected: isRowSelected,
      onRowSelectionChange: onRowSelectionChange
    }), (selectedCellProps === null || selectedCellProps === void 0 ? void 0 : selectedCellProps.dragHandleProps) && /*#__PURE__*/React.createElement("div", Object.assign({
      className: "rdg-cell-drag-handle"
    }, selectedCellProps.dragHandleProps)));
  }

  return /*#__PURE__*/React.createElement("div", Object.assign({
    role: "gridcell",
    "aria-colindex": column.idx + 1,
    "aria-selected": isSelected,
    ref: useCombinedRefs(cellRef, ref),
    className: className,
    style: {
      width: column.width,
      left: column.left
    },
    onKeyDown: selectedCellProps ? wrapEvent(selectedCellProps.onKeyDown, onKeyDown) : onKeyDown,
    onClick: isEditing ? onClick : wrapEvent(handleClick, onClick),
    onDoubleClick: isEditing ? onDoubleClick : wrapEvent(handleDoubleClick, onDoubleClick),
    onContextMenu: isEditing ? onContextMenu : wrapEvent(handleContextMenu, onContextMenu)
  }, props), getCellContent());
}

export default /*#__PURE__*/memo( /*#__PURE__*/forwardRef(Cell));